import api from '../token';

export const DeleteVeiculo = async (dados) => {
  try {
    const response = await api.post('/deleteVeiculo', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};
